import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Link} from 'react-router-dom'
import {IPost} from '../../../models/Post'
import {postCategoryMessages} from '../../config/commonMessages'
import {PHOTO_RATIO} from '../../config/constants'
import {datebyComma} from '../../helpers/dateUtil'
import {getPostUrl} from '../../helpers/post'
import defaultProfile from '../../assets/imgs/profile-default.png'
import ResponsiveImg from '../common/ResponsiveImg'
import {useAmp} from '../hocs/hooks'
import styles from './PostThumbnail.scss'

const thumbWidth = 224 //px
const PostThumbnail = ({post}: {post: IPost, className?: string}) => {
  const {
    photo,
    title,
    categories: [category],
    date,
    author
  } = post
  const amp = useAmp()
  const releaseDate = datebyComma(date)
  return <div className={['mb-2 mb-md-3 mr-3 mr-md-4', styles.container].join(' ')}>
    <div className="overflow-hidden">
      <Link to={getPostUrl(post, false, amp)}
            className={styles.imgWrapper}>
        <ResponsiveImg
          noContainer
          url={photo}
          caption={title}
          width={thumbWidth}
          height={thumbWidth / PHOTO_RATIO}
          className={styles.photo}
        />
      </Link>
    </div>
    <div className="m-2 p-1 text-left">
      {category && <div className="text-gray font-weight-medium small mb-1">
        <FormattedMessage {...postCategoryMessages[category]}/>
      </div>}
      <Link to={getPostUrl(post, false, amp)}
            className={['font-weight-bold ellipsis text-black', styles.title].join(' ')}>
        {title}
      </Link>
      <div className={['d-flex font-weight-medium', styles.subText].join(' ')}>
        <div className="text-black d-flex align-items-center">
          {releaseDate}
        </div>
        <div className="ml-auto d-flex align-items-center text-gray">
          <div className={['mr-2 ellipsis text-right', styles.name].join(' ')}>
            {author?.name　|| <FormattedMessage id="deleteAccount.label"/>}
          </div>
          <div>
            <ResponsiveImg caption="author picture"
                          url={author?.picture || defaultProfile}
                          className="rounded-circle"
                          height={24}
                          width={24}/>
          </div>
        </div>
      </div>
    </div>
  </div>
}
PostThumbnail.displayName = 'PostThumbnail'
export default PostThumbnail

export const PostThumbnailList = ({posts}: {posts: ReadonlyArray<IPost>}) => {
  return <>
    {posts?.length
      ? posts.map(post => <PostThumbnail post={post} key={post._id} className="mr-3"/>)
      : <div className="text-center">
        <FormattedMessage id="post.noPost"/>
      </div>
    }
  </>
}
PostThumbnailList.displayName = 'PostThumbnailList'
